import CustomSelect from "../CustomSelect";
import "./style.css";

interface IProps {
  name: string;
  value: any;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  className?: string;
  containerClassName?: string;
  label: string;
  showClear?: boolean;
  showSearch?: boolean;
  error?: string;
  disabled?: boolean;
  loading?: boolean;
}

const InputSelect = ({
  name,
  value,
  onChange,
  options,
  className = "",
  containerClassName = "",
  label,
  showClear,
  showSearch,
  error,
  disabled,
  loading,
}: IProps) => {
  return (
    <div className={`f-select-container ${containerClassName}`}>
      <label htmlFor={name} className={`f-select-label ${error ? "error" : ""}`}>
        {label}
      </label>
      <CustomSelect
        value={value}
        onChange={(val) => onChange(val || "")}
        options={options}
        showClear={showClear}
        showSearch={showSearch}
        className={`f-select-input ${className} ${error ? "error" : ""}`}
        disabled={disabled || loading}
      />

      {error && <small className="f-select-error">{error}</small>}
    </div>
  );
};

export default InputSelect;
